import { VenueDto } from '@ivy-monorepo/shared'
import { apiClient } from './api-client'

class CustomerService {
  async getVenues(): Promise<VenueDto[]> {
    const response = await apiClient.get(`/customer/venues`)
    return response.data
  }

  async getVenue(publicId: string): Promise<VenueDto> {
    const response = await apiClient.get(`/customer/venues/${publicId}`)
    return response.data
  }

  async updateVenueSpecial(
    venuePublicId: string,
    specialPublicId: string,
    dto: any
  ): Promise<void> {
    await apiClient.post(`/customer/venues/${venuePublicId}/specials/${specialPublicId}`, dto)
  }

  async createVenueSpecial(venuePublicId: string, dto: any): Promise<void> {
    await apiClient.post(`/customer/venues/${venuePublicId}/specials`, dto)
  }
}

export const customerService = new CustomerService()
